import React from "react";
import { Link } from "react-router-dom";
import { store, wallet } from "../../../assets/icons/Web";

interface IProps {
  dropdownProduct: boolean;
  handleShowSideBar: () => void;
}

const ProductSubsidebar: React.FC<IProps> = ({
  dropdownProduct,
  handleShowSideBar,
}) => {
  return (
    <div>
      {dropdownProduct && (
        <li className="py-2 ml-7 flex flex-row flex-wrap justify-between items-center">
          <div className="flex">
            <img
              src={wallet}
              className="md:w-7 w-4 md:h-7 h-4 md:mr-5 mr-4"
              alt="icon"
            />
            <Link
              onClick={handleShowSideBar}
              className={
                "md:text-lg text-sm font-medium items-center cursor-pointer " +
                (window.location.href.indexOf("/marketplace/product-depatu") !==
                -1
                  ? "text-black hover:text-gray-300"
                  : "text-gray-600 hover:text-gray-300")
              }
              to="/marketplace/product-depatu"
            >
              Product Depatu
            </Link>
          </div>
        </li>
      )}

      {dropdownProduct && (
        <li className="py-2 mt-5 ml-7 flex flex-row flex-wrap justify-between items-center">
          <div className="flex">
            <img
              src={store}
              className="md:w-7 w-4 md:h-7 h-4 md:mr-5 mr-4"
              alt="icon"
            />
            <Link
              onClick={handleShowSideBar}
              className={
                "md:text-lg text-sm font-medium items-center cursor-pointer " +
                (window.location.href.indexOf(
                  "/marketplace/product-need-review"
                ) !== -1
                  ? "text-black hover:text-gray-300"
                  : "text-gray-600 hover:text-gray-300")
              }
              to={{
                pathname: "/marketplace/product-need-review",
              }}
            >
              Product Need Review
            </Link>
          </div>
        </li>
      )}

      {dropdownProduct && <hr className="md:my-5 my-3 md:min-w-full" />}
    </div>
  );
};

export default ProductSubsidebar;
